module.exports = __webpack_public_path__ + "assets/img/patientList-picman.52375b77.png";